import Vue from 'vue'
import Vuex from 'vuex'
import * as api from '@/service/api'

Vue.use(Vuex)




// 设置 cookie
const ut_setCookie = (value)=> {
  var d = new Date();
  d.setTime(d.getTime()+(1*24*60*60*1000));
  document.cookie = "mx_token="+ value + ";expires=" + d.toGMTString();
}


export default new Vuex.Store({
  state: {
    vx_token: '',
    vx_userInfo: null,
    vx_isShowLogin: false,
    vx_loginDefaultIdx: null, // 登录时默认显示的面板（1-快捷登录 2-账号登录）
    vx_loginTimestamp: 0,
    vx_searchText: "",
    vx_uuid: '',  // 发送验证码前进行图片校验的识别码
    vx_message_detail: {}
  },
  getters: {
    vx_get_token(state) {
      return state.vx_token || localStorage.token
    },
    vx_get_uuid(state) {
      return state.vx_uuid
    },
    vx_get_message(state){
      return state.vx_message_detail || {}
    }
  },
  mutations: {
    vx_setData(state, obj) {
      Object.assign(state, obj)
    },
    vx_setToken(state, v) {
      state.vx_token = v
      localStorage.token = v
      ut_setCookie(v);
    },
    vx_toggleLogin(state, reverse = !state.vx_isShowLogin) {
      state.vx_isShowLogin = reverse
    },
    vx_setUserInfo(state, obj) {
      state.vx_userInfo = Object.assign({}, state.vx_userInfo, obj)
      window.localStorage.setItem('mx_userInfo', JSON.stringify(state.vx_userInfo));
    },
    vx_doLogout(state) {
      let flag = !!state.vx_token
      localStorage.removeItem('token')
      state.vx_token = ''
      state.vx_userInfo = null
      let keys = document.cookie.match(/[^ =;]+(?==)/g)
      if (keys) {
        for (var i = keys.length; i--;) {
          document.cookie = keys[i] + '=';
        }
      }
      if (flag) state.vx_loginTimestamp = new Date() * 1
    },
    vx_set_searchText(state, text) {
      state.vx_searchText = text;
    },
    vx_set_message(state,detail){
      state.vx_message_detail = {...detail}
    }
  },
  actions: {
    vx_act_findOne({ commit }, config = {}) {
      return api.findOne().then(res => {
        if (res.isOk) {
          commit('vx_setData', {vx_userInfo: null})
          commit('vx_setUserInfo', {
            phone: config.phone || '',
            ...res.data
          })
        }
        return res
      })
    }
  },
  modules: {}
})
